import { AddViewSupport410Container } from "../../../containers/SupportSystem/ViewReports/AddViewSupport410Container"
export function AddViewSupport410Page() {
    return (
        <AddViewSupport410Container />
    )
}